import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

const DateTimePicker = ({
  dateTime,
  setDateTime,
}: {
  dateTime: Date | null | undefined;
  setDateTime: (dateTime: Date) => void;
}) => {
  const handleDateChange = (e: any) => {
    const newDate = new Date(dateTime?.getTime() || Date.now());
    const [year, month, day] = e.target.value.split('-');
    newDate.setFullYear(parseInt(year, 10));
    newDate.setMonth(parseInt(month, 10) - 1); // Months are 0-based
    newDate.setDate(parseInt(day, 10));
    newDate.setSeconds(0);
    setDateTime(newDate);
  };

  const handleTimeChange = (e: any) => {
    const newDate = new Date(dateTime?.getTime() || Date.now());
    const [hours, minutes] = e.target.value.split(':');
    newDate.setHours(parseInt(hours, 10), parseInt(minutes, 10));
    newDate.setSeconds(0);
    setDateTime(newDate);
  };

  const dateValue =
    dateTime != null
      ? `${dateTime.getFullYear()}-${String(dateTime.getMonth() + 1).padStart(
          2,
          '0',
        )}-${String(dateTime.getDate()).padStart(2, '0')}`
      : undefined;
  const timeValue =
    dateTime != null
      ? `${String(dateTime.getHours()).padStart(2, '0')}:${String(
          dateTime.getMinutes(),
        ).padStart(2, '0')}`
      : undefined;

  return (
    <FormGroup>
      <Label for="date">Date:</Label>
      <Input
        type="date"
        name="date"
        id="date"
        value={dateValue}
        onChange={handleDateChange}
      />
      <Label for="time">Time:</Label>
      <Input
        type="time"
        name="time"
        id="time"
        value={timeValue}
        onChange={handleTimeChange}
      />
    </FormGroup>
  );
};

export default DateTimePicker;
